import { render } from "./info.vue?vue&type=template&id=c67c778c&scoped=true"
import script from "./info.vue?vue&type=script&lang=js"
export * from "./info.vue?vue&type=script&lang=js"

import "./info.vue?vue&type=style&index=0&id=c67c778c&scoped=true&lang=css"

import exportComponent from "/Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c67c778c"]])

export default __exports__
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../../../../../../../Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTd});
